// ============================================================================
// PORTUGUESE BIBLE PASSAGES - Almeida Revista e Atualizada
// ============================================================================
// Passagens bíblicas em português com referências Strong

export const biblePassagesPt = {
  "Genesis_1": {
    book: "Gênesis",
    chapter: 1,
    title: "A Criação do mundo",
    verses: [
      { number: 1, text: "No princípio, criou Deus os céus e a terra.", strong: ["H7225", "H430", "H1254"] },
      { number: 2, text: "A terra, porém, estava sem forma e vazia; havia trevas sobre a face do abismo, e o Espírito de Deus pairava por sobre as águas.", strong: ["H776", "H8414", "H7307"] },
      { number: 3, text: "Disse Deus: Haja luz; e houve luz.", strong: ["H430", "H559", "H216"] },
      { number: 4, text: "E viu Deus que a luz era boa; e fez separação entre a luz e as trevas.", strong: ["H430", "H7200", "H216", "H2896"] },
      { number: 5, text: "Chamou Deus à luz Dia e às trevas, Noite. Houve tarde e manhã, o primeiro dia.", strong: ["H430", "H7121", "H3117", "H3915"] },
      { number: 6, text: "E disse Deus: Haja firmamento no meio das águas e separação entre águas e águas.", strong: ["H430", "H7549", "H4325"] },
      { number: 7, text: "Fez, pois, Deus o firmamento e separação entre as águas debaixo do firmamento e as águas sobre o firmamento. E assim se fez.", strong: ["H430", "H6213", "H7549"] },
      { number: 8, text: "E chamou Deus ao firmamento Céus. Houve tarde e manhã, o segundo dia.", strong: ["H430", "H7121", "H8064"] },
      { number: 27, text: "Criou Deus, pois, o homem à sua imagem, à imagem de Deus o criou; homem e mulher os criou.", strong: ["H430", "H1254", "H120", "H6754"] },
      { number: 31, text: "Viu Deus tudo quanto fizera, e eis que era muito bom. Houve tarde e manhã, o sexto dia.", strong: ["H430", "H7200", "H2896", "H3966"] }
    ]
  },
  "Salmo_23": {
    book: "Salmos",
    chapter: 23,
    title: "O SENHOR é o meu pastor",
    verses: [
      { number: 1, text: "O SENHOR é o meu pastor; nada me faltará.", strong: ["H3068", "H7462", "H2637"] },
      { number: 2, text: "Ele me faz repousar em pastos verdejantes. Leva-me para junto das águas de descanso.", strong: ["H7257", "H4999", "H5148", "H4325"] },
      { number: 3, text: "Refrigera-me a alma. Guia-me pelas veredas da justiça por amor do seu nome.", strong: ["H7725", "H5315", "H5148", "H6664"] },
      { number: 4, text: "Ainda que eu ande pelo vale da sombra da morte, não temerei mal nenhum, porque tu estás comigo; o teu bordão e o teu cajado me consolam.", strong: ["H1980", "H1516", "H6757", "H3372", "H7626"] },
      { number: 5, text: "Preparas-me uma mesa na presença dos meus adversários, unges-me a cabeça com óleo; o meu cálice transborda.", strong: ["H6186", "H7979", "H6887", "H1878", "H3563"] },
      { number: 6, text: "Bondade e misericórdia certamente me seguirão todos os dias da minha vida; e habitarei na Casa do SENHOR para todo o sempre.", strong: ["H2896", "H2617", "H7291", "H3117", "H1004", "H3068"] }
    ]
  },
  "Joao_3": {
    book: "João",
    chapter: 3,
    title: "Jesus e Nicodemos",
    verses: [
      { number: 16, text: "Porque Deus amou o mundo de tal maneira que deu o seu Filho unigênito, para que todo o que nele crê não pereça, mas tenha a vida eterna.", strong: ["G2316", "G25", "G2889", "G1325", "G5207"] },
      { number: 17, text: "Porquanto Deus enviou o seu Filho ao mundo, não para que julgasse o mundo, mas para que o mundo fosse salvo por ele.", strong: ["G2316", "G649", "G2889", "G2919", "G4982"] },
      { number: 18, text: "Quem nele crê não é julgado; o que não crê já está julgado, porquanto não crê no nome do unigênito Filho de Deus.", strong: ["G4100", "G2919", "G3686", "G5207", "G2316"] }
    ]
  },
  "Filipenses_4": {
    book: "Filipenses",
    chapter: 4,
    title: "A paz de Deus",
    verses: [
      { number: 4, text: "Alegrai-vos sempre no Senhor; outra vez digo: alegrai-vos!", strong: ["G5463", "G2962", "G3825"] },
      { number: 6, text: "Não andeis ansiosos de coisa alguma; em tudo, porém, sejam conhecidas, diante de Deus, as vossas petições, pela oração e pela súplica, com ações de graças.", strong: ["G3309", "G4335", "G1162", "G2169"] },
      { number: 7, text: "E a paz de Deus, que excede todo o entendimento, guardará o vosso coração e a vossa mente em Cristo Jesus.", strong: ["G1515", "G2316", "G5242", "G3563", "G5432"] },
      { number: 13, text: "Tudo posso naquele que me fortalece.", strong: ["G1411", "G1743", "G5547"] }
    ]
  }
};

export default biblePassagesPt;
